import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  DomineOwnersRequest extends  DBObject {  private static readonly _DOMINE: number = 0 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _domine: string = '' ;
 public constructor ( d3eParams ? : Partial<{domine: string}> ) {
 super();

this.setDomine(d3eParams?.domine ?? '');
 }
  public get d3eType (  ) : string {
 return 'DomineOwnersRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get domine (  ) : string {
 return this._domine ; 
 }
  public setDomine ( val : string ) : void {
 let isValChanged :boolean=this._domine !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(DomineOwnersRequest._DOMINE,this._domine);

this._domine=val;

this.fire('domine',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case DomineOwnersRequest._DOMINE : {
 return this._domine ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : DomineOwnersRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :DomineOwnersRequest=( dbObj as DomineOwnersRequest );

obj.id=this.id;

obj.setDomine(this._domine);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case DomineOwnersRequest._DOMINE : {
 this.setDomine(( value as string ));
 break; }
 }
 }
 }